import React, { useRef, useState, useEffect } from 'react'
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './FundViewOrg.css';

import useEffectOnce from '../hooks/useEffectOnce';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { GFNButton } from '../ui/GFNButton';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import { fetchdata, fetchviewdata, messageData, sendmsgdata, ApproveData, RejectData } from '../reduxactions/fundmanagersactions/ViewOrgActions';
import { useLocation, useParams } from 'react-router-dom';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';




export const FundViewOrg = () => {
  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');
  const location = useLocation();
  // const [date, setDate] = useState<Date | null>(new Date());
  const [edate, setDate] = useState<Date | null>(new Date());


  const [queryParams, setQueryParams] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("application_id") as any);
  }, [location]);
  const { application_id } = useParams();

  const usertype = window.sessionStorage.getItem('usertype');



  console.log('Row ID:', application_id);
  const dispatch = useDispatch()
  const data = useSelector((state: RootState) => state.orgapplication.data);
  const viewdocsdata = useSelector((state: RootState) => state.orgapplication.viewdocdata);
  const chatdata = useSelector((state: RootState) => state.orgapplication.Chatdata);
  const msgdata = useSelector((state: RootState) => state.orgapplication.successdata);
  const approvedata = useSelector((state: RootState) => state.orgapplication.approvedata);
  const rejsData = useSelector((state: RootState) => state.orgappapplication.rejectdata);

  const toast = useRef(approvedata);
  const Closebutton = async () => {

    setApproveConfirmation(false);


  }

  //To get data//view tabale data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(application_id, uid) as any);
    } catch (error) {
    }
  };
  //   attachements data
  const fetchDataViewAsync = async () => {
    try {
      await dispatch(fetchviewdata(application_id) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
    fetchDataViewAsync();

  }, [dispatch]);
  // To get data//chat data
  const fetchDatachatAsync = async () => {
    try {
      await dispatch(messageData(uid, usertype, application_id) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  useEffectOnce(() => {

    fetchDatachatAsync();
  }, [dispatch])

  const [message, setMessage] = useState<string>('');
  const AddsMessage = async () => {
    try {
      await dispatch(sendmsgdata(uid, message, application_id) as any);
      setMessage('');
    } catch (error) {
      console.error('Error fetching data', error)
    }

    fetchDatachatAsync();
  }
  //approve code
  const [approveConfirmation, setApproveConfirmation] = useState(false);
  const [appData, setApproveeData] = useState({
    id: '',

  });

  const Approve = (response: any) => {
    setApproveeData({
      id: '',
    });
    setApproveConfirmation(true);
  };
  const confirmApprove = async () => {
    const { id } = appData;
    try {
      await dispatch(ApproveData(application_id, edate) as any);
      toast.current.show({ severity: 'success', summary: 'Approved Successfully', detail: approvedata, life: 3000 })
      setApproveConfirmation(false);
    } catch (error) {
      console.error('Error approving :', error);
    }
    fetchDataAsync();
  };
  //reject code
  const toast1 = useRef(rejsData);
  const [needs, setneed] = useState('');

  const [rejectConfirmation, setRejectConfirmation] = useState(false);
  const [rejData, setRejecteData] = useState({
    id: '',

  });
  const Reject = (response: any) => {
    setRejecteData({
      id: response.application_id

    });
    setRejectConfirmation(true);
  };
  const confirmReject = async () => {
    const { id } = rejData;
    try {
      await dispatch(RejectData(application_id) as any);
      toast1.current.show({ severity: 'success', summary: 'Rejected Successfully', detail: rejsData, life: 5000 })
      setRejectConfirmation(false);
    } catch (error) {
      console.error('Error while rejecting', error);
    }
    fetchDataAsync();
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/viewfmorganizationapplication.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">View Organization Application</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            <Panel>
              {data.map((response: any) =>
                <section className="content">
                  <Panel header="About Fundmanager">
                    <div className="grid">
                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Fund Manager Name:</strong>
                          <p className="text-muted">{response.name}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>WebSite :</strong>
                          <p className="text-muted">{response.website_url}</p>
                        </div>
                      </div>
                    </div>
                  </Panel>
                  <Panel header="Organization Information">
                    <div className="grid">

                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Name :</strong>
                          <p className="text-muted">{response.nameoftheorg}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Head :</strong>
                          <p className="text-muted">{response.nameofthehead}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Designation :</strong>
                          <p className="text-muted">{response.designation}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License No:</strong>
                          <p className="text-muted">{response.licenseno}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License Expired Date :</strong>
                          <p className="text-muted">{response.license_expdate}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Type :</strong>
                          <p className="text-muted">{response.suborg_type}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Application Expired Date :</strong>
                          <p className="text-muted">{response.exp_date}</p>
                        </div>

                      </div>
                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Email :</strong>
                          <p className="text-muted">{response.email}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Address :</strong>
                          <p className="text-muted">{response.address}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Contact No :</strong>
                          <p className="text-muted">{response.mobile}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Country :</strong>
                          <p className="text-muted">{response.CountryName}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Paypal Account :</strong>
                          <p className="text-muted">{response.paypal_account}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Status :</strong>
                          <p className="text-muted">{response.status}</p>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </section>
              )}
              <section className="content">
                <Panel header="Attachments">
                  <div className="grid">
                    <div className="col-12">
                      <div className="card card-primary">
                        <div className="card flex flex-wrap justify-content">
                          <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                          </span>
                        </div>
                        <DataTable value={viewdocsdata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                          <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                          <Column field="doc_name" sortable header="Attachment Name"></Column>
                          <Column field="expiry_date" sortable header="Expiry Date"></Column>

                        </DataTable>

                      </div>
                    </div>
                  </div>
                </Panel>
                <Panel header="Chat">
                  {chatdata.map((response: any) =>

                    <div className="grid">
                      <div className="col-2">
                        <p>{response.name}, {response.date} </p>
                      </div>
                      <div className="col-9">
                        <p>{response.msg} </p>
                      </div>
                    </div>
                  )}
                  <div className="card-footer">
                    <div className="grid">
                      <div className='col-11'>
                        <InputText value={message} placeholder="Type Message ..." className="w-full mb-10" onChange={(e) => setMessage(e.target.value)} />
                      </div>
                      <span className="input-group-btn">
                        <div className='col-1'>
                          <Button severity="info" icon="pi pi-send" rounded outlined onClick={AddsMessage} />
                        </div>
                      </span>
                    </div>
                  </div>
                </Panel>
                <div className='grid'>
                  <div className='col-9'></div>
                  <div className='col-3'>
                    {data.map((response: any) => (
                      response.status === 'Approved' && (
                        <Button className='mr-1' severity="danger" label="Reject" rounded onClick={() => Reject(response)} />

                      )
                    ))}
                    {data.map((response: any) => (
                      response.status === 'Rejected' && (
                        <Button className='mr-1' severity="success" label="Approve" rounded onClick={() => Approve(response)} />
                      )
                    ))}
                    {data.map((response: any) => (
                      response.status === 'Applied' && (
                        <Button className='mr-1' severity="success" label="Approve" rounded onClick={() => Approve(response)} />
                      )
                    ))}
                    {data.map((response: any) => (
                      response.status === 'Applied' && (
                        <Button className='mr-1' severity="danger" label="Reject" rounded onClick={() => Reject(response)} />

                      )
                    ))}
                  </div>
                </div>
              </section>
            </Panel>
            <Dialog header="Confirm Reject" style={{ width: '30vw' }} visible={rejectConfirmation} onHide={() => setRejectConfirmation(false)}>
              <div>Are you sure you want to Reject this item?</div>
              <Button label="Yes" icon="pi pi-check" className='mr-3 p-button-raised' onClick={confirmReject} />
              <Button label="No" icon="pi pi-times" onClick={Closebutton} className="mr-3 p-button-secondary" />
            </Dialog>

            <Dialog header="Aprrove" style={{ width: '30vw' }} visible={approveConfirmation} onHide={() => setApproveConfirmation(false)}>
              <div className="grid pt-3">
                <div className="col-8">
                  <label htmlFor="dd-mm-yyyy" className="col-sm-2 control-label">Expiry Date:</label>
                </div>
                <div className="col-7" >
                  <span className="p-float-label">


                    <Calendar className="calendar-container"
                      id="expdate"
                      style={{ width: '200px' }} // Adjust width as needed
                      name="date"
                      placeholder='dd-mm-yyyy'
                      onChange={(e) => e.value && setDate(e.value)}
                      showIcon
                    />

                  </span>
                </div>
              </div>
              <Button label='Close' onClick={Closebutton} className="mr-3 p-button-secondary" />
              <Button label='Approve' className="mr-3 p-button-primary" onClick={confirmApprove} />
            </Dialog>
            <Toast ref={toast} >
              <Message severity="success" content={approvedata} />
            </Toast>
            <Toast ref={toast1} >
              <Message severity="success" content={rejsData} />
            </Toast>
          </div>
        </div>
      </div>
    </div>
  )
}
export default FundViewOrg